import { Box, Divider } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { CopyButton, PluInfo, StoreInfo } from 'components/debug-tool';
import { MenuObjectTypes } from 'enums/menu';
import { IWithVendorConfig, findVendorConfig } from 'utils/vendor-config';

import { getSanityDocumentUrl } from '../utils';

export const SelectedItemDebug = ({
  selectedItemVendorConfig,
  productName,
  posVendor,
  selectedItemType,
  hideTitle = false,
  hidePosVendor = false,
}: {
  selectedItemVendorConfig: IWithVendorConfig & { _id: string };
  productName: string;
  posVendor: string;
  selectedItemType: MenuObjectTypes;
  hideTitle?: boolean;
  hidePosVendor?: boolean;
}) => {
  if (!selectedItemVendorConfig.vendorConfigs) {
    return null;
  }

  const vendorConfig = findVendorConfig(selectedItemVendorConfig.vendorConfigs, posVendor);

  return (
    <Box marginY="$2">
      {!hidePosVendor && (
        <>
          <StoreInfo />
          <Divider marginBottom="$6" />
        </>
      )}
      {!hideTitle && <Typography variant="headerOne">Selected Product:</Typography>}
      <CopyButton
        label={productName}
        textToCopy={getSanityDocumentUrl(selectedItemType, selectedItemVendorConfig._id)}
        variant="headerTwo"
        iconName="mi:content-copy"
      />
      {vendorConfig && <PluInfo vendorConfig={vendorConfig} />}
    </Box>
  );
};
